export default __webpack_public_path__ + "static/media/pie-chart.631446be.svg";